/**
 * Salesletter direct-checkout (Omforta parity for Dawn).
 * Ajax ATC so theme listeners + Shopify/web pixels see an add, then settle
 * before unload so beacons can flush — then redirect to checkout.
 */
(function () {
  if (window.__kijimeaSalesLetterCheckoutDirect) return;
  window.__kijimeaSalesLetterCheckoutDirect = true;

  var PIXEL_SETTLE_MS = 500;
  var SOURCE = 'kijimea-salesletter-checkout-direct';

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  }

  function cartClearUrl() {
    return '/cart/clear.js';
  }

  function cartJsonUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base.replace(/\/$/, '') + '.js';
  }

  function checkoutUrl() {
    return '/checkout' + window.location.search;
  }

  function cartFallbackUrl() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return base + window.location.search;
  }

  function resolveVariantId(button) {
    var direct = button.getAttribute('data-variant-id');
    if (direct) return Number(direct);

    var lifeRoot = button.closest('[data-sales-letter-life-offer]');
    if (lifeRoot) {
      var checked = lifeRoot.querySelector('input[name="life-offer-variant"]:checked');
      if (checked && checked.value) return Number(checked.value);
    }

    return null;
  }

  /** Bundle cards: data-variant-ids="123,456" → one line item per id (qty 1). */
  function resolveVariantItems(button) {
    var quantity = Number(button.getAttribute('data-quantity')) || 1;
    var bundleProperty = (button.getAttribute('data-bundle-property') || '').trim();
    var properties = bundleProperty ? { _bundle: bundleProperty } : undefined;

    function withProps(item) {
      if (!properties) return item;
      return { id: item.id, quantity: item.quantity, properties: properties };
    }

    var multi = button.getAttribute('data-variant-ids');
    if (multi) {
      return multi
        .split(',')
        .map(function (part) {
          return Number(String(part).trim());
        })
        .filter(function (id) {
          return Number.isFinite(id) && id > 0;
        })
        .map(function (id) {
          return withProps({ id: id, quantity: 1 });
        });
    }

    var single = resolveVariantId(button);
    if (!single) return [];
    return [withProps({ id: single, quantity: quantity })];
  }

  function resolveCheckoutUrl(button) {
    var url = checkoutUrl();
    var code = (button.getAttribute('data-discount-code') || '').trim();
    if (!code) return url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'discount=' + encodeURIComponent(code);
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = !!busy;
    if (busy) {
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');
    } else {
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');
    }
  }

  /** BFCache / back-from-checkout: page restores with disabled + spinner still on. */
  function clearAllBusy() {
    document.querySelectorAll('[data-add-to-checkout].is-loading, [data-add-to-checkout][aria-busy="true"]').forEach(function (button) {
      setBusy(button, false);
    });
  }

  // Fires on first load (noop) and when restoring from BFCache (back from checkout).
  window.addEventListener('pageshow', function () {
    clearAllBusy();
  });

  function publishCartUpdate(variantId, cartData) {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: SOURCE,
        productVariantId: String(variantId),
        cartData: cartData,
        // Signal drawers / auto-open listeners to stay closed on salesletters.
        skipAutoOpen: true,
      });
    }
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { source: SOURCE, skipAutoOpen: true, productVariantId: String(variantId) },
      })
    );
  }

  async function addAndRedirectToCheckout(button) {
    var items = resolveVariantItems(button);
    if (!items.length) return;

    var primaryVariantId = items[0].id;
    setBusy(button, true);

    try {
      // Clean slate so checkout matches the offer click (same as Omforta).
      await fetch(cartClearUrl(), {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
      });

      var addResponse = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items }),
      });

      var addData = await addResponse.json().catch(function () {
        return {};
      });

      if (!addResponse.ok || addData.status) {
        console.warn(
          '[sales-letter-checkout] cart/add failed:',
          addData.description || addData.message || addData
        );
        setBusy(button, false);
        return;
      }

      var cartResponse = await fetch(cartJsonUrl(), { credentials: 'same-origin' });
      var ajaxCart = await cartResponse.json().catch(function () {
        return addData;
      });

      // Same ATC signal path as PDP Ajax adds (pubsub + cart:updated).
      publishCartUpdate(primaryVariantId, ajaxCart);

      // Let theme listeners + web pixels flush before unload.
      await wait(PIXEL_SETTLE_MS);

      // bundle-sl only: if shopper abandons checkout and returns to the shop, clear cart.
      if (document.body && document.body.classList.contains('bundle-sl')) {
        try {
          sessionStorage.setItem('kijimea-bundle-sl-clear-on-return', '1');
        } catch (e) {
          /* private mode */
        }
      }

      window.location.assign(resolveCheckoutUrl(button));
    } catch (error) {
      console.warn('[sales-letter-checkout] redirect error:', error);
      window.location.assign(cartFallbackUrl());
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-add-to-checkout]');
      if (!button || button.disabled) return;
      event.preventDefault();
      addAndRedirectToCheckout(button);
    },
    true
  );

  window.kijimeaAddAndRedirectToCheckout = addAndRedirectToCheckout;
})();
